/* ===================================
   CUSTOM FAUVE — JS overrides
   =================================== */

/* Ticket 1 + 3 — Header sticky sur la home
   Sur la home, la logique sticky native du thème ne se déclenche pas
   correctement. On force l'ajout de la classe is-sticky au scroll,
   sur mobile ET desktop. */
document.addEventListener('DOMContentLoaded', function() {
  
  const header = document.querySelector('theme-header');
  if (!header) return;
  
  // S'applique uniquement si on est sur la home (template-index)
  const isHomePage = document.body.classList.contains('template-index');
  if (!isHomePage) return;
  
  function handleStickyOnHome() {
    if (window.scrollY > 100) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', handleStickyOnHome, { passive: true });
  window.addEventListener('resize', handleStickyOnHome);
  handleStickyOnHome();
});

